import React from 'react'
import QuestionsCollapse from '../QuestionsCollapse'
import History from './History'
import { getAnswerByQuestion } from '../../../../../../../../../utils/question.helper'

const HistorySection = ({ question, answers }) => {
    return question.children ? (
        <QuestionsCollapse question={question} answers={answers} ContentComponent={History} />
    ) : (
        <History question={question} answer={getAnswerByQuestion(answers, question)} />
    )
}

export default HistorySection
